import React, { useState } from 'react';
import axios from 'axios';

const VideoUpload = () => {
    const [file, setFile] = useState(null);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            alert('Vui lòng chọn một file video.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('FileId', '469');
        formData.append('StatusId', '3');
        formData.append('CategoryId', '38');
        formData.append('LangId', 'vi');
        formData.append('LinkVideo', '');
        formData.append('Description', 'VTV1: Chào buổi sáng số ngày 10/01/2025');
        formData.append('Name', 'VTV1: Chào buổi sáng số ngày 10/01/202523213');
        formData.append('Id', '20');
        formData.append('CoreId', '31');
        

        try {
            const result = await axios.post(
                'https://api.canhsatpccc.gov.vn/api/admin/Video/Update',
                formData,
                {
                    headers: {
                        'accept': 'application/json',
                        'authorization': 'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJhN2NkNmM2MC1jZWE3LTRhYWUtYTc1MC01MTRlMWQ3NGQxZTgiLCJ1c2VyTmFtZSI6ImFkbWluQGdtYWlsLmNvbSIsImZ1bGxOYW1lIjoiQWRtaW5pc3RyYXRvciIsImVtYWlsIjoiYWRtaW5AZ21haWwuY29tIiwidXNlclJvbGUiOiJBRE1JTiIsImF2YXRhciI6IiIsImV4cGlyZVRpbWUiOiIxLzI0LzIwMjUgMTA6MzI6MzMgQU0iLCJ0ZWxlcGhvbmVOdW1iZXIiOiIwOTY4ODgzODk4IiwiZXhwIjoxNzM3Njg5NTUzfQ.-HLircYpduzAnLU0pGIZmcTnvuUlfvroF65AmX333L0',
                 },
                }
            );
            setResponse(result.data);
            setError(null);
        } catch (err) {
            setError(err.message);
            setResponse(null);
        }
    };

    return (
        <div>
            <h1>Upload Video</h1>
            <form onSubmit={handleSubmit}>
                <input type="file" onChange={handleFileChange} accept="video/*" />
                <button type="submit">Upload</button>
            </form>

            {response && (
                <div>
                    <h2>Phản hồi từ server:</h2>
                    <pre>{JSON.stringify(response, null, 2)}</pre>
                </div>
            )}

            {error && (
                <div>
                    <h2>Lỗi:</h2>
                    <p>{error}</p>
                </div>
            )}
        </div>
    );
};

export default VideoUpload;